export const ApiCallRequestTypes = {
    excelFormat:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
